import Navbar from '../components/Navbar/Navbar';
import Footer from '../sections/Footer/Footer';
import Gallery from '../sections/Gallery/Gallery';

const GalleryPage = () =>{
return(
    <>
           <Navbar/>
           <Gallery />
           <Footer />
    </>
);
}

export default GalleryPage;